<rcl-text-field
  [group]="emailForm"
  [type]="'text'"
  [label]="(resourceBundle.bundle | async)['ctc.email.label']"
  [control]="'email'"
></rcl-text-field>

@for (error of errors().email; track error) {
  <rcl-error-message>{{ error }}</rcl-error-message>
}
